import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Clock } from "lucide-react";
import { stripMarkdownFormatting } from "@/lib/stripMarkdown";

interface Version {
  iteration: number;
  prompt: string;
  aiOutput: string;
  createdAt: string;
}

interface VersionComparisonProps {
  currentVersion: Version;
  previousVersion: Version;
}

export const VersionComparison = ({ currentVersion, previousVersion }: VersionComparisonProps) => {
  return (
    <div className="grid md:grid-cols-2 gap-4">
      <Card className="p-4">
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <h4 className="font-semibold">Iteration {previousVersion.iteration}</h4>
            <Badge variant="outline" className="text-xs">
              <Clock className="w-3 h-3 mr-1" />
              Previous
            </Badge>
          </div>
          
          <div>
            <p className="text-xs text-muted-foreground mb-2">Prompt Used:</p>
            <ScrollArea className="h-24 rounded-md border bg-muted/30 p-2">
              <p className="text-xs whitespace-pre-wrap">{previousVersion.prompt}</p>
            </ScrollArea>
          </div>

          <div>
            <p className="text-xs text-muted-foreground mb-2">Output:</p>
            <ScrollArea className="h-48 rounded-md border bg-muted/30 p-2">
              <div 
                className="text-sm whitespace-pre-wrap"
                dangerouslySetInnerHTML={{ __html: stripMarkdownFormatting(previousVersion.aiOutput) }}
              />
            </ScrollArea>
          </div>
        </div>
      </Card>

      <Card className="p-4 border-primary">
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <h4 className="font-semibold">Iteration {currentVersion.iteration}</h4>
            <Badge className="text-xs">
              <Clock className="w-3 h-3 mr-1" />
              Current
            </Badge>
          </div>
          
          <div>
            <p className="text-xs text-muted-foreground mb-2">Prompt Used:</p>
            <ScrollArea className="h-24 rounded-md border bg-muted/30 p-2">
              <p className="text-xs whitespace-pre-wrap">{currentVersion.prompt}</p>
            </ScrollArea>
          </div>

          <div>
            <p className="text-xs text-muted-foreground mb-2">Output:</p>
            <ScrollArea className="h-48 rounded-md border bg-primary/5 p-2">
              <div 
                className="text-sm whitespace-pre-wrap"
                dangerouslySetInnerHTML={{ __html: stripMarkdownFormatting(currentVersion.aiOutput) }}
              />
            </ScrollArea>
          </div>
        </div>
      </Card>
    </div>
  );
};
